import Icon from 'veui/components/Icon'
import { IconZoomIn } from 'dls-icons-vue'

Icon.register('zoom-in', IconZoomIn)
